import styled from '@emotion/styled';
import { Ui } from '@silvertours/front-shared';

// ToDo: use theme variables to ensure a unified design
const Wrapper = styled.div<{ isIntersecting: boolean }>`
  position: ${({ isIntersecting }) => (isIntersecting ? 'fixed' : 'relative')};
  top: 0;
  left: 0;
  width: 100%;
  z-index: 100;
  margin: 0;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  padding: 0.5rem 1rem;
  color: ${({ theme }) => theme.colors.neutral.grey160};
  font-size: 1.0625rem;
  font-weight: 600;
  font-style: normal;
  line-height: 1.5rem;

  &::after {
    content: '';
    display: none;
    width: 100%;
    height: 0.5em;
  }

  a:link {
    color: ${({ theme }) => theme.colors.neutral.grey160};
    font-weight: 700;
  }

  a:visited {
    color: ${({ theme }) => theme.colors.neutral.grey160};
  }

  a:focus-visible {
    outline-color: currentcolor;
  }

  &.important {
    background-color: ${({ theme }) => theme.colors.brand.orange80};
  }

  &.less-important {
    background-color: ${({ theme }) => theme.colors.neutral.grey80};
    color: ${({ theme }) => theme.colors.neutral.black100};

    a:link {
      color: ${({ theme }) => theme.colors.neutral.black100};
    }

    a:visited {
      color: ${({ theme }) => theme.colors.neutral.black100};
    }

    .close {
      fill: ${({ theme }) => theme.colors.neutral.black100};
    }
  }

  &.regular-black {
    background-color: ${({ theme }) => theme.colors.neutral.black100};
    color: white;

    a {
      color: inherit;
    }
  }

  &.regular-green {
    background-color: ${({ theme }) => theme.colors.brand.green80};
  }

  .close {
    position: absolute;
    right: ${({ theme }) => theme.spacing[40]};
    top: ${({ theme }) => theme.spacing[20]};
    background-color: transparent;
    width: ${({ theme }) => theme.spacing[50]};
    border: none;
    fill: ${({ theme }) => theme.colors.neutral.grey160};
    cursor: pointer;
  }

  ${({ theme }) => theme.mq('md')} {
    justify-content: center;
  }
`;

const CloseButton = styled(Ui.IconButton)`
  position: absolute;
  right: ${({ theme }) => theme.spacing[40]};
  top: ${({ theme }) => theme.spacing[20]};
  color: ${({ theme }) => theme.colors.neutral.grey160};

  &:focus-visible {
    outline-color: currentcolor;
  }
`;

export { Wrapper, CloseButton };
